import React from "react";

export default function Alert(props) {
  const { type, message, children } = props;
  return (
    <div className={`alert alert-${type} alert-dismissable`}>
      {/*<button type="button" className="close" data-dismiss="alert" aria-hidden="true">×</button>*/}
      {children || message}
    </div>
  );
}
